import React,{useEffect,useState} from 'react';
import {staffApi} from '@/lib/staffApi';
import {formatMoney} from '@/lib/format';

export function SavedCardControl({appointmentId,balancePence,disabled,onCharge}){
    const [card,setCard]=useState(null),[error,setError]=useState('');
    useEffect(()=>{let active=true;setCard(null);setError('');(async()=>{
        try{const result=await staffApi.savedCard(appointmentId);if(active)setCard(result);}
        catch{if(active)setError('Saved-card permission could not be checked. You can still use the payment link or another payment method.');}
    })();return()=>{active=false;};},[appointmentId,balancePence]);
    return <section className="rounded-xl border border-gold/40 p-4 space-y-2" aria-label="Saved card payment">
        {!card&&!error&&<p className="text-sm">Checking saved-card permission…</p>}
        {error&&<p className="text-sm">{error}</p>}
        {card?.available===false&&<p className="text-sm">{card.message}</p>}
        {card?.available&&<><p>{card.brand} ending {card.last4} · {formatMoney(balancePence/100)} remaining</p><p className="text-sm text-white/70">Authorised for this appointment. Angela must confirm before any charge is made.</p><button type="button" disabled={disabled} onClick={()=>onCharge(card)} className="rounded-full bg-gold text-navy px-5 py-3 font-semibold disabled:opacity-40">Charge saved card {formatMoney(balancePence/100)}</button></>}
    </section>;
}
